'use client';

import {
  WishlistCard as SharedWishlistCard,
  type SharedWishlistCardData,
  type WishlistCardItem,
} from '@veranda/shared/components/wishlist-card';
import { cn } from '@veranda/shared/lib';

export function WishlistCard({
  product,
  item,
  boardId,
  className,
}: {
  product: SharedWishlistCardData;
  item: WishlistCardItem;
  boardId?: string;
  className?: string;
}) {
  return (
    <SharedWishlistCard
      className={cn(
        'flex flex-col overflow-hidden border border-gray-200',
        className
      )}
    >
      <SharedWishlistCard.ImageContainer
        product={product}
        className="aspect-square w-full overflow-hidden"
      />

      <SharedWishlistCard.Content className="p-3">
        <div className="space-y-2">
          <SharedWishlistCard.Title
            product={product}
            className="line-clamp-2 font-medium text-sm"
          />
          <div className="flex items-center justify-between">
            <SharedWishlistCard.Price
              product={product}
              priceClassName="font-semibold text-sm"
            />
            <SharedWishlistCard.RemoveButton
              item={item}
              boardId={boardId}
              className="text-gray-400 hover:text-red-500"
            />
          </div>
        </div>
      </SharedWishlistCard.Content>
    </SharedWishlistCard>
  );
}
